// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from './Brand';
import Links from './Links';
import SidebarCard from './SidebarCard';
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  const { routes } = props;

  // SIDEBAR
  return (
    <Flex direction='column' height='100%' pt='16px' px="16px" borderRadius='30px'>
      <Brand />
      <Stack direction='column' mb='auto' mt='4px'>
        <Box ps='20px' pe={{ md: "16px", "2xl": "1px" }}>
          <Links routes={routes} />
        </Box>
      </Stack>

      <Box mt="auto">
        <Box
          borderRadius='30px'
          mb='16px'
        >
          <SidebarCard />
        </Box>
      </Box>
    </Flex>
  );
}

export default SidebarContent;